@if (icon(); as icon) {
  <svg-icon [key]="icon" />
}

<div class="message">{{ toast().message.trim() }}</div>

<button tk-close-button variant="inverse" (click)="close()"></button>
